import React from 'react';

import { Container } from 'components/Grid';

import Feature from './components/Feature';

import {
  Section,
  List,
} from './styles';

const Features = () => {

  return (
    <Section>
      <Container flex direction="column" align="center">
        <List>
          <Feature name="EASY" color="#fa4933" />
          <Feature isInverted name="ENGAGING" color="#7726fd" />
          <Feature isGetStarted name="SAVE_MONEY" color="#ffa500" />
          <Feature isInverted name="TRANSPARENT" color="#13b84e" />
          <Feature isGetStarted name="COMPLETE" color="#ff2725" />
        </List>
      </Container>
    </Section>
  );
};

export default Features;
